import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { ProjectContext } from "@/stores/project-provider";

import { SubmitModelSchemaToApiArgs } from "../types/submit-model-schema-args";

export const useSubmitSchematisation = () => {
  const project = useContext(ProjectContext);

  return useMutationWithErrorHandler((props: SubmitModelSchemaToApiArgs) => {
    return getRanaApiV1().ThreediSchematisationsApi.modelSchematisationsSubmit({
      projectId: project.id,
      ...props,
    });
  });
};
